export const parseTemplate = (templateSrc) => {
    const usedPlaceholders = Array.from(
        // LAST WORKING templateSrc.matchAll(/\[=[a-z,A-Z,[\],_,0-9]+\[*\]\.[a-z,A-Z,_,0-9]+\]/g),
        templateSrc.matchAll(/\[=[a-zA-Z[\]_,0-9]+\[*\]\.[a-zA-Z_,0-9]+\]/g),
        (match) => match[0],
    );

    return usedPlaceholders;
};

export const parseTemplateConditions = (templateSrc) => {
    const usedPlaceholderConditions = Array.from(
        templateSrc.matchAll(/\[#if([a-zA-Z[\]_0-9.?=()<>"&|; ])+\]/g),
        /* LAST WORKING templateSrc.matchAll(
            /\[#if([a-z,A-Z,[\],_,0-9,.,?,=,(,),<,>,",&,|,;, ])+\]/g,
        ), */
        (match) => match[0],
    );
    return usedPlaceholderConditions;
};

export const parseTemplateIterators = (templateSrc) => {
    const listPattern = /\[#list\s+(\w+)\s+as\s+(\w+)\](.*?)\[\/#list\]/gs;
    const iteratorVariablesPattern = /\[=(\w+).(\w+)\]/gs;
    let gmatch = [];
    let imatch = [];
    const usedPlaceholderIterators = [];
    while ((gmatch = listPattern.exec(templateSrc)) !== null) {
        const group = {
            group: gmatch[1],
            prefix: gmatch[2],
            body: gmatch[3].trim(),
            variables: [],
        };
        while ((imatch = iteratorVariablesPattern.exec(group.body)) !== null) {
            group.variables.push(imatch[2]);
        }
        group.variables = group.variables.concat(parseTemplateIteratorConditions(group.body));
        usedPlaceholderIterators.push(group);
    }
    return usedPlaceholderIterators;
};

export const parseTemplateIteratorConditions = (htmlPattern) => {
    const conditionRegex = /\[#if\s+item\.[^\]]+\s+\]/gs;
    const conditionMatches = htmlPattern.matchAll(conditionRegex);
    const result = [];

    for (const smatch of conditionMatches) {
        const variableMatches = smatch[0].match(/item\.(\w+)/g);
        if (variableMatches) {
            variableMatches.forEach((imatch) => {
                const im = imatch.split('.');
                result.push(im[1]);
            });
        }
    }
    return result;
};

export const transformPlaceholderConditionNames = (placeholderConstruct) => {
    const fullNames = Array.from(
        /* LAST WORKING placeholderConstruct.matchAll(
            /[a-z,A-Z,[\],_,0-9]+\[*\]\.[a-z,A-Z,_,0-9]+/g,
        ), */
        placeholderConstruct.matchAll(/[a-zA-Z[\]_,0-9]+\[*\]\.[a-zA-Z_,0-9]+/g),
        (match) => match[0],
    );
    const result = [];

    if (fullNames.length > 0) {
        for (let fn in fullNames) {
            const fullName = fullNames[fn];
            const groupPattern = /\[0]/g;
            const fullNameClear = fullName.replace(groupPattern, '');
            const splitted = fullNameClear.split('.');
            const groupName = splitted[0];
            const ident = splitted[1];

            result.push({
                templateSyntax: placeholderConstruct,
                fullName: fullName,
                group: groupName,
                ident: ident,
                as: 'condition',
            });
        }
    }
    return result;
};

export const transformPlaceholderIteratorNames = (placeholderConstructs) => {
    const result = [];
    for (let i in placeholderConstructs) {
        const item = placeholderConstructs[i];
        item.variables.map((v) => {
            result.push({
                templateSyntax: `[=${item.prefix}.${v}]`,
                fullName: `${item.prefix}.${v}`,
                group: item.group,
                ident: v,
                as: 'iterator',
            });
        });
    }
    return result;
};

export const transformPlaceholderNames = (placeholderConstruct) => {
    // LAST WORKING const fullNamePattern = /^\[=|\]$/g;
    // LAST WORKING const fullName = placeholderConstruct.replace(fullNamePattern, '');
    const fullName = placeholderConstruct.slice(2, -1);
    const groupPattern = /\[0]/g;
    const fullNameClear = fullName.replace(groupPattern, '');
    const splitted = fullNameClear.split('.');
    const groupName = splitted[0];
    const ident = splitted[1];
    const result = {
        templateSyntax: placeholderConstruct,
        fullName: fullName,
        group: groupName,
        ident: ident,
        as: 'variable',
    };
    return result;
};

export const harvestTemplate = async (sourceHTML, usedPlaceholdersExport = []) => {
    //First run, single variables [=groug[0].var]
    const usedPlaceholdersStatic = parseTemplate(sourceHTML);
    for (let key in usedPlaceholdersStatic) {
        let placeholderComplete = transformPlaceholderNames(usedPlaceholdersStatic[key]);
        usedPlaceholdersExport.push(placeholderComplete);
    }
    //Second run, conditions [#if ...]
    const usedPlaceholderConditions = parseTemplateConditions(sourceHTML);
    for (let key in usedPlaceholderConditions) {
        let placeholderConditionComplete = transformPlaceholderConditionNames(
            usedPlaceholderConditions[key],
        );

        // Final merge
        for (let x in placeholderConditionComplete) {
            const test = placeholderConditionComplete[x];
            const search = usedPlaceholdersExport.find(
                (item) => item.group == test.group && item.ident == test.ident,
            );

            if (typeof search === 'undefined') {
                usedPlaceholdersExport.push(test);
            }
        }
    }
    //Third run, lists [#list ...]
    const usedPlaceholderIterators = parseTemplateIterators(sourceHTML);
    const placeholderIteratorComplete = transformPlaceholderIteratorNames(usedPlaceholderIterators);

    for (let x in placeholderIteratorComplete) {
        const test = placeholderIteratorComplete[x];
        const search = usedPlaceholdersExport.find(
            (item) => item.group == test.group && item.ident == test.ident,
        );

        if (typeof search === 'undefined') {
            usedPlaceholdersExport.push(test);
        }
    }
    return usedPlaceholdersExport;
};

export const useFreemarker = async () => {
    return {
        parseTemplate: parseTemplate,
        parseTemplateConditions: parseTemplateConditions,
        parseTemplateIterators: parseTemplateIterators,
        parseTemplateIteratorConditions: parseTemplateIteratorConditions,
        transformPlaceholderNames: transformPlaceholderNames,
        transformPlaceholderConditionNames: transformPlaceholderConditionNames,
        transformPlaceholderIteratorNames: transformPlaceholderIteratorNames,
        harvestTemplate: harvestTemplate,
    };
};

export default useFreemarker;
